import React from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';
import Icon from '@mui/material/Icon';

import ChatGptStar from '../../../../assets/chatgpt-star.svg';
import ChatGptLoading from '../../../../assets/animation/ChatGptLoading.gif';
import { useTranslation } from 'react-i18next';
import { AI_DISCLAIMER_LINK } from '../../../../consts/consts';

const ChatGptInterpretation = ({ open, onClose, position, loading, interpretedText }) => {
	const { t } = useTranslation('reports');

	return (
		<Popover
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			anchorPosition={{ top: position?.top + position?.height + 5, left: position?.left + 0 }}
			anchorReference="anchorPosition"
			id="chat-gpt-interpretation"
			open={open}
			sx={{
				'.MuiPopover-paper': {
					borderRadius: '0px 20px 20px 20px',
					background:
						'linear-gradient(89.43deg, #BC67FF 4.76%, #8E71FF 32.42%, #7BBFFE 65.71%, #5EE2FF 94.78%)',
					backgroundClip: 'padding-box',
					padding: '3px',
				},
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			onClose={onClose}
		>
			<Box
				sx={{
					minHeight: '110px',
					minWidth: '192px',
					maxHeight: '400px',
					maxWidth: '370px',
					borderRadius: '0px 20px 20px 20px',
					boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
					background: '#393939',
				}}
			>
				<Typography
					sx={{
						paddingTop: '15px',
						paddingLeft: '44px',
						color: 'rgba(255, 255, 255, 0.87)',
						fontFamily: 'Roboto',
						fontSize: '14px',
						fontStyle: 'normal',
						fontWeight: '500',
						lineHeight: '20px' /* 142.857% */,
					}}
				>
					{t('AI says')}
				</Typography>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<Icon
						component={ChatGptStar}
						data-testid="chatgpt-star-icon"
						sx={{
							width: '24px',
							height: '24px',
							paddingLeft: '15px',
							paddingRight: '5px',
						}}
					/>

					{loading ? (
						<Box
							data-testid="chatgpt-loading"
							sx={{
								width: '115px',
								height: '45px',
								backgroundPosition: 'center',
								backgroundRepeat: 'no-repeat',
								backgroundSize: '100%',
								backgroundImage: `url(${ChatGptLoading})`,
							}}
						/>
					) : (
						<Box
							sx={{
								boxSizing: 'border-box',
								padding: '11px 16px',
								borderRadius: '0px 20px 20px 20px',
								background: 'rgba(0, 0, 0, 0.40)',
								width: '303px',
								marginRight: '25px',
								marginBottom: `${loading ? '25px' : '5px'}`,
								maxHeight: '290px',
								overflow: 'auto',
							}}
						>
							<Typography
								sx={{
									color: '#fff',
									fontFamily: 'Roboto',
									fontSize: '14px',
									fontStyle: 'normal',
									fontWeight: '400',
									lineHeight: '20px' /* 142.857% */,
								}}
							>
								{interpretedText}
							</Typography>
						</Box>
					)}
				</Box>
				{!loading && (
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
						}}
					>
						<WarningIcon
							data-testid="warning-icon"
							sx={{
								fontSize: '16px',
								color: '#42A5F5',
								paddingLeft: '15px',
							}}
						/>
						<Typography
							sx={{
								paddingLeft: '5px',
								paddingRight: '15px',
								paddingBottom: '10px',
								color: '#42a5f5',
								fontFamily: 'Roboto',
								fontSize: '12px',
								fontStyle: 'normal',
								align: 'center',
								lineHeight: '14px' /* 142.857% */,
								wordWrap: 'break-word',
								span: {
									cursor: 'pointer',
									textDecoration: 'underline',
									'&:hover': {
										textDecoration: 'none',
									},
								},
							}}
						>
							{`${t(
								'The AI technology serves as an analytical aid, the ultimate responsibility for patient diagnosis and care lies with licensed healthcare providers who must interpret and validate any AI-generated reports. '
							)}`}
							<span onClick={() => window.open(AI_DISCLAIMER_LINK)}>
								{`(${t('Detailed disclaimer')})`}
							</span>
						</Typography>
					</Box>
				)}
			</Box>
		</Popover>
	);
};

export default ChatGptInterpretation;
